export default __webpack_public_path__ + "static/media/aeroplane.90ad8602.png";